import PropTypes from 'prop-types';
import {useState} from 'react';

import {PSR_TYPES} from '../../../constants/typesMessages';
import {useChatStore} from '../../../store/slices/chatStore';
import {usePsrStore} from '../../../store/slices/psrStore';
import PsrCodeInput from '../../PsrCodeInput';
import {PsrsGroup} from '../../PsrsGroup';

export const MessagePsrsPhysical = (props) => {
  const psrGroupTypes = usePsrStore((state) => state.psrGroupTypes);
  const setMessages = useChatStore((state) => state.setMessages);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const setChatInputCode = useChatStore((state) => state.setChatInputCode);
  const setChaListCode = useChatStore((state) => state.setChaListCode);
  const setPsrInputOwnerId = useChatStore((state) => state.setPsrInputOwnerId);
  const [isActive, setIsActive] = useState(true);

  const handleSavePsrSelection = (psrNamesMessage) => {
    sendMessage({
      text: psrNamesMessage,
      type: 'message-sent'
    });
  };

  const cancelStepPsrSelection = () => {
    setChatInputCode([]);
    setChaListCode([]);
    setPsrInputOwnerId(null);
    setIsActive(false);

    setMessages([
      {text: 'Cancelar', type: 'message-sent'},
      {
        type: PSR_TYPES.PSR_PAYMENT
      }
    ]);
  };

  const cancelStepPsrIdMultivan = () => {
    setChatInputCode([]);
    setChaListCode([]);
    setPsrInputOwnerId(null);
    setIsActive(false);

    setMessages([
      {text: 'Cancelar', type: 'message-sent'},
      {
        type: PSR_TYPES.PSR_PHYSICAL
      }
    ]);
  };

  const saveStepPsrIdMultivan = () => {
    sendMessage({
      text: 'Os dados fornecidos referentes às maquininhas de Pagamentos Presenciais estão corretos?',
      type: PSR_TYPES.PSR_CONFIRM
    });
  };

  return (
    <>
      <div className="message-line">
        <div className="message-receive" id={`msg-${props.question.id}`}>
          <div className="message-div">
            <p>
              Beleza! Vamos seguir com o credenciamento em{' '}
              <strong>Maquininhas para Pagamentos Presenciais</strong>. Por
              favor, selecione abaixo qual(is) maquininha(s) você deseja
              habilitar.
            </p>
          </div>
        </div>
      </div>
      {isActive && (
        <>
          <PsrsGroup
            showPsr={psrGroupTypes.physical}
            cancelButton={cancelStepPsrSelection}
            onSave={handleSavePsrSelection}
            stepId={props.question.id}
          />
          <PsrCodeInput
            saveButton={saveStepPsrIdMultivan}
            cancelButton={cancelStepPsrIdMultivan}
            stepId={props.question.id}
          />
        </>
      )}
    </>
  );
};

MessagePsrsPhysical.propTypes = {
  question: PropTypes.object
};
